import st from "@/styles/Ui.module.scss";
import LinearProgress from "@mui/material/LinearProgress";
import {useTranslation} from "react-i18next";
import {useEffect} from "react";
import useAuth from "@/hooks/auth.ts";



const KYCProcessingListener = () => {
    const {t} = useTranslation()
    const auth = useAuth()
    const user = auth.current_user()
    const is_processing = Boolean(user?.kyc_general_status === "UserFinished" || user?.kyc_general_status === "ServerProcessing")
    const queryParams = new URLSearchParams(location.search);
    const debug = queryParams.get("debug")
    
    useEffect(() => {
        let interval = setInterval(async() => {
            await auth.small_update().then((x) => {
                if(debug === "true") console.info("setInterval user small_update 3", x)
                if(x.kyc_general_status !== "ServerProcessing" && x.kyc_general_status !== "UserFinished"){
                    clearInterval(interval)
                }
            })
            
        }, 5000)
        
        return () => {
            clearInterval(interval)
        }
    }, []);
    
    if (is_processing) {
        return (
            <div className={st.user_identity_processing}>

                <span>
                    {t("processing_kyc1")}
                </span>

                <LinearProgress color="success"/>
            </div>
        )
    } else null
}

export default KYCProcessingListener